import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClientsService } from '@services/clients.service';
import { UiService } from '@services/ui.service';

export interface DialogData {
  clientId: string
}

@Component({
  selector: 'app-dialog-koovea-management',
  templateUrl: './dialog-koovea-management.component.html',
  styleUrls: ['./dialog-koovea-management.component.scss']
})
export class DialogKooveaManagementComponent {
  isLoading = false;
  editMode = false;

  kooveaLogin = null;
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogKooveaManagementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private clientsSrv: ClientsService,
    private fb: FormBuilder,
    private uiSrv: UiService
  ) { }


  ngOnInit(): void {
    this.initSub();
  }

  initSub() {
    this.getLogin();
  }

  getLogin() {
    this.isLoading = true;
    this.clientsSrv.getKooveaLogin(this.data.clientId).subscribe((kooveaLogin) => {
      this.isLoading = false;
      this.kooveaLogin = kooveaLogin;

    })
  }

  modify() {
    this.editMode = true;
    this.form = this.fb.group({
      login: [this.kooveaLogin ? this.kooveaLogin.login : null, Validators.required],
      password: [null, Validators.required],
      clientId: [this.data.clientId]
    });
  }

  cancel() {
    this.editMode = false;
    this.form.reset();
  }

  validate(event) {
    if (event) {
      if (this.kooveaLogin) {
        this.update();
      } else {
        this.create()
      }
    } else {
      this.cancel();
    }
  }

  create() {
    this.clientsSrv.postKooveaLogin(this.form.value).subscribe(
      {
        next: () => {
          this.uiSrv.showSnackbar('Création du login Koovea réussie.');
          this.getLogin();
          this.cancel();
        }, error: (error) => {
          this.cancel();
        }
      }
    )
  }

  update() {
    this.clientsSrv.putKooveaLogin(this.form.value).subscribe(
      {
        next: () => {
          this.uiSrv.showSnackbar('Mise à jour du login Koovea réussie.');
          this.getLogin();
          this.cancel();
        }, error: (error) => {
          this.cancel();
        }
      }
    )
  }
}
